import { SET_FILTERS } from './types';

const setFilters = (payload) => ({
	type: SET_FILTERS,
	payload
});

export default setFilters;
